import styled from "@emotion/styled"
import { css } from "@emotion/react"

// container of Modal
export const ModalContainer = css`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 900;
    align-items: baseline;
`

// flexbox of Modal content
export const ModalBoxCSS = css`
    transform: translateY(0px);
    margin: 3rem auto !important;
    width: 75%;
    box-sizing: border-box;
    height: auto;
    display: flex;
    flex-direction: column;
    left: 0;
    right: 0;
    position: absolute;
    transition: transform .2s;
    z-index: 1;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
    background: white;
`

// greyed out overlay of modal when visible
export const ModalOverlay = styled.div`
    width: 100vw;
    height: 100vh;
    z-index: 0;
    background: rgba(0, 0, 0, 0.5);
`

// CSS for header of modal content
export const Header = css`
    padding: 2.2rem 2rem 1rem;
`

// title text in header
export const HeaderText = css`
    letter-spacing: 0.01em;
    height: 40px;
    font-size: 14px;
    font-weight: 700;
    border-bottom: 1px solid #c1c1c1;
    padding-bottom: 10px;
    margin-bottom: 0;
    min-height: 1em;
    word-wrap: break-word;
    line-height: 20px;
    vertical-align: middle;
    @media (min-width: 768px) {
        line-height: 60px;
        font-size: 26px;
        font-weight: 300;
        height: 70px;
    }
`

// close "x" button in corner
export const HeaderButton = styled.button`
    padding: 20px !important;
    background-image: none;
    background: none;
    -moz-box-sizing: content-box;
    border: 0;
    box-shadow: none;
    line-height: inherit;
    margin: 0;
    padding: 0;
    text-shadow: none;
    font-weight: 400;
    display: inline-block;
    text-decoration: none;
    position: absolute;
    right: 0;
    top: 0;
    outline: none !important;
    &:before {
        font-size: 14px;
        line-height: 14px;
        color: #757575;
        content: "\\e616";
        font-family: 'Luma-Icons' !important;
        margin: 0;
        vertical-align: top;
        display: inline-block;
        font-weight: normal;
        overflow: hidden;
        speak: none;
        text-align: center;
        cursor: pointer;
        &:hover {
            font-weight: bold;
        }
    }
`

// content of message in modal:
export const Message = css`
    padding-left: 2rem;
    padding-right: 2rem;
    font-size: 14px;
`

// container of content of message:
export const ModalFooter = css`
    padding: 2rem;
    margin-top: auto;
    // flex-grow?
`

// ok button in footer of modal:
export const ModalButton = styled.button`
    background-image: none;
    background: #eee;
    border: 1px solid #ccc;
    cursor: pointer;
    font-weight: 500;
    padding: 3px 15px;
    box-sizing: border-box;
    vertical-align: middle;
    outline: none !important;
    &:hover span {
        color: white;
    }
    &:hover {
        background: rgb(38, 107, 175)
    }
`






